import BasicSearchTable from './BasicSearchTable';

export default BasicSearchTable;



// WEBPACK FOOTER //
// ./src/components/BasicSearchTable/index.js